<template>
  <div id="system-journal-setting-general-alert">
    <ipub-model :title="'Add New Voucher'"
                width="800px"
                :visable="isVisable"
                @confirm="confirm"
                @cancel="cancel">
      <div class="ipub-p2 mar-b-10">
        <ipub-form ref="journal-option-form"
                   :model="params"
                   :rules="rules">
          <ipub-form-item prop="discount"
                          style="margin-bottom:0;"
                          label="">
            <ipub-input placeholder="Amount"
                        number
                        :fixed="0"
                        v-model.trim="params.discount" />
          </ipub-form-item>

        </ipub-form>
      </div>

    </ipub-model>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { discountJournalId } from '@/api/discount'


export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    }
  },
  data () {
    return {
      params: {
      },
      rules: {},
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      journalId: 'getJournalId',
      publisherId: 'getPublisherId'
    })
  },
  watch: {
    isVisable (val) {
      if (!val) {
        this.params = {}
      }
    }
  },
  mounted () {

  },
  methods: {
    async confirm () {
      const flag = this.$refs['journal-option-form'].validate()
      if (!flag) {
        return
      }
      await discountJournalId.addDiscount(this.journalId, this.params.discount)

      this.$message.success({ title: 'Success', content: 'Added successfully!' })
      this.$emit('confirm')
    },
    cancel () {
      this.$emit('cancel')
    },
    getRules () {
      this.rules = {
        discount: [
          {
            min: 1, message: 'Voucher value must be greater than zero!'
          }
        ]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
